import {createSlice, isAnyOf, type SliceSelectors} from '@reduxjs/toolkit'

import {
    changeRechargePoint,
    selectComplexPayMethod,
    selectNormalPayMethodTab,
    selectMobilePayMethod,
    selectVoucherMethod,
    cancelEasyMobileRegistration,
    SelectPaymentMethodActions,
} from '@web/actions/paymentMethod'
import {restoreSavedState, restoreState} from '@web/actions/restoreState'
import {MobileEasyPayPinStatus} from '@web/core/constants'
import {
    changeEasyMobileNewPin,
    changeEasyMobilePinStatus,
    inputEasyMobileNumbers,
    inputEasyMobilePinNo,
    inputMobileNumbers,
    changeMobileEasyPayApiStatus,
    getInitialState,
} from '@web/slices/mobile/slice'

import type {MobileReducers, MakeSliceOptions} from './interfaces'
import type {MobileState} from '@web/slices/mobile/slice'

export default (options?: MakeSliceOptions) =>
    createSlice<MobileState, MobileReducers, 'mobile', SliceSelectors<MobileState>>({
        name: 'mobile',
        initialState: getInitialState(),
        reducers: {},
        extraReducers: (builder) => {
            builder
                .addCase(inputMobileNumbers, (state, {payload}) => {
                    state.mobileGeneralPay.phoneNumbers = payload
                })
                .addCase(inputEasyMobileNumbers, (state, {payload}) => {
                    state.mobileEasyPay.phoneNumbers = payload
                })
                .addCase(inputEasyMobilePinNo, (state, {payload}) => {
                    state.mobileEasyPay.pinNo = payload
                })
                .addCase(changeEasyMobilePinStatus, (state, {payload}) => {
                    state.mobileEasyPay.pinStatus = payload
                    state.mobileEasyPay.newPinNo = ''
                    state.mobileEasyPay.confirmPinNo = ''
                })
                .addCase(changeEasyMobileNewPin, (state, {payload}) => {
                    state.mobileEasyPay.newPinNo = payload.newPinNo
                    state.mobileEasyPay.confirmPinNo = payload.confirmPinNo
                })
                .addCase(cancelEasyMobileRegistration, (state) => {
                    state.mobileEasyPay.isRegistration = false
                    state.mobileEasyPay.phoneNumbers = ''
                    state.mobileEasyPay.pinNo = ''
                    state.mobileEasyPay.newPinNo = ''
                    state.mobileEasyPay.confirmPinNo = ''
                })
                .addCase(changeMobileEasyPayApiStatus, (state, {payload}) => {
                    state.mobileEasyPay.apiStatus = payload
                })
            options?.extraReducers?.(builder)
            builder
                .addMatcher(
                    isAnyOf(
                        selectMobilePayMethod,
                        selectVoucherMethod,
                        selectNormalPayMethodTab.fulfilled,
                        selectComplexPayMethod.fulfilled,
                        changeRechargePoint.fulfilled,
                        ...SelectPaymentMethodActions,
                    ),
                    (state) => {
                        state.mobileEasyPay.pinStatus = MobileEasyPayPinStatus.IDLE
                    },
                )
                .addMatcher(isAnyOf(restoreSavedState.fulfilled, restoreState), (state, {payload}) => {
                    return payload.mobile ?? state
                })
        },
    })
